class TMv_SMA_UtilityMenus
{
	current_hover = false;

	constructor(element)
	{
		this.element = element;

		// Level 1 li tags
		this.element.querySelectorAll('.l_1').forEach( el => {
			el.addEventListener('mouseenter',this.utilityMenuOver.bind(this));
			el.addEventListener('mouseleave',this.utilityMenuOut.bind(this));

		});

		// Level 1 links
		this.element.querySelectorAll('.l_1 > a').forEach( el =>{
			el.addEventListener('focus',this.utilityMenuOver.bind(this));
			el.addEventListener('click', this.utilityMenuClick.bind(this));

		});


	}

	utilityMenuClick(event)
	{
		let parent_li = event.target.closest('li');
		if(parent_li && parent_li.classList.contains('has_children'))
		{
			event.preventDefault();
		}
	}

	removeHoverClass()
	{
		let current_menu = this.element.querySelector('.menu_hover_showing');
		if(current_menu)
		{
			current_menu.classList.remove('menu_hover_showing');
		}
	}

	utilityMenuOver(event)
	{
		let button = event.target;

		this.removeHoverClass();

		button.closest('li').classList.add('menu_hover_showing');

	}

	utilityMenuOut(event)
	{
		let new_element = event.relatedTarget;

		// Still in menus
		if(new_element && new_element.classList.contains('submenu_wrapper')
		)
		{
			return;
		}

		this.removeHoverClass();

	}


}